import Suspense from "components/shared/Suspense";
import { lazy, useState } from "react";
import { useDispatch } from "react-redux";
import { searchActions } from "store/search/searchSlice";
import ReportBookButton from "./ReportBookButton";
import { PageSerializersBooksLayout } from "types/serializers";

const DuplicateModal = lazy(() => import("../parts/DuplicateModal"));

export interface Props {
  book: PageSerializersBooksLayout;
}

export default function ReportBookButtonContent({ book }: Props) {
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const dispatch = useDispatch();

  const toggleDuplicate = () => {
    setShowDuplicateModal(!showDuplicateModal);
  };

  const onClose = () => {
    setShowDuplicateModal(false);
    dispatch(searchActions.reset());
  };

  return (
    <>
      <ReportBookButton book={book} onDuplicate={toggleDuplicate} />

      {showDuplicateModal && (
        <Suspense>
          <DuplicateModal onClose={onClose} object={book} type="Books" />
        </Suspense>
      )}
    </>
  );
}
